const stringParam = 'string';
export const ALL_STEPS = [
    {
        name: 'Vertical step',
        key: 'vertical-step',
        urlParams: [['vertical', stringParam]],
    }, // Choose vertical among the five hard-coded. Psychology will only trigger a pop-up saying to download the app. Note that the QA section at the botton here is outdated: it explains differences between in-clinic and video appointments, and the link to FAQ does not work.
    {
        name: 'Practitioner type step',
        key: 'practitioner-type-step',
        urlParams: [
            ['speciality', stringParam],
            ['service', stringParam],
        ],
    }, // Choose practitioner type and/or type of appointment (video/in-clinic), or city. If only one practitioner, go to next step. Practitioner types and clinics are gotten from Sanity (Specialists).
    //{
    //   name: 'Service type step',
    //   key: 'service-type-step',
    //   urlParams: [['service', stringParam]],
    // }, // Select "service" for a given practitioner type. The services are fetched based on service categories in WW: it gets all services within a category with the name equal to the "specialist" param.
    {
        name: 'Location step',
        key: 'location-step',
        urlParams: [['city', stringParam]],
    },
    {
        name: 'Clinic step',
        key: 'clinic-step',
        urlParams: [['clinicId', stringParam]],
    },
    {
        name: 'Select practitioner step',
        key: 'practitioner-step',
        urlParams: [['practitionerId', stringParam]],
    },
    {
        name: 'Date/time step',
        key: 'Date/Time-step',
        urlParams: [],
    },
    {
        name: 'Personal details step',
        key: 'personal-details-step',
        urlParams: [],
    },
    {
        name: 'Confirm sms step',
        key: 'confirm-sms-step',
        urlParams: [],
    },
    {
        name: 'Receipt step.',
        key: 'receipt-step.',
        urlParams: [],
    },
];
